<p-toolbar>
  <ng-template pTemplate="start">
    <img src="/logo.svg" alt="logo" style="width: 34px; height: 34px;">
  </ng-template>
  <ng-template pTemplate="end">
    <p-button (click)="testException()" label="Test Exception" />
    @if(isLoggedIn()){
      <p-button routerLink="/logout">{{'Log Out'|transloco}}</p-button>
    }
<!--    <p-divider layout="vertical"/>-->
<!--    <p-select-->
<!--      [options]="langs"-->
<!--      [(ngModel)]="lang"-->
<!--      optionLabel="label"-->
<!--      optionValue="value"-->
<!--      (onChange)="chlang($event)"-->
<!--    />-->
  </ng-template>
</p-toolbar>

<div class="router-container">
  <router-outlet />
</div>
